var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inactive-module"},[_c('img',{attrs:{"src":require("@/assets/img/inactive-module/Import.jpg")},on:{"click":_vm.openTips}})])}
var staticRenderFns = []

export { render, staticRenderFns }